import CongratsPage from './CongratsPage'

export default CongratsPage
